import { render, staticRenderFns } from "./ShowCom.vue?vue&type=template&id=08a652fd&scoped=true&"
import script from "./ShowCom.vue?vue&type=script&lang=js&"
export * from "./ShowCom.vue?vue&type=script&lang=js&"
import style0 from "./ShowCom.vue?vue&type=style&index=0&id=08a652fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a652fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data-jenkins/jenkins/workspace/html-cube-webapi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08a652fd')) {
      api.createRecord('08a652fd', component.options)
    } else {
      api.reload('08a652fd', component.options)
    }
    module.hot.accept("./ShowCom.vue?vue&type=template&id=08a652fd&scoped=true&", function () {
      api.rerender('08a652fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DesignEditor/component/panel/ShowCom.vue"
export default component.exports